import { initLucideIcons } from './lucide';

document.addEventListener('lucide:refresh', initLucideIcons);
